import React, { FC, ReactNode } from "react";
import CheckBox from "../Checkbox";
import { useTranslation } from "react-i18next";

export const SelectTagArea: FC<{
  options: OptionProps[];
  defaultSelected?: OptionPropsValue[];
  onSelect: (options: OptionProps[]) => void;
  title?: string;
  maxSelectable?: number;
  children?: React.ReactNode;
  groupNodes?: Record<string, ReactNode>;
  className?: string;
  disabled?: boolean;
  priority?: boolean;
  containerClassName?: string;
  isCheckbox?: boolean;
}> = ({
  options,
  children,
  defaultSelected,
  onSelect,
  title,
  maxSelectable = 1,
  groupNodes,
  className,
  disabled,
  priority,
  containerClassName,
  isCheckbox,
}) => {
  const { t } = useTranslation();
  if (!options || options.length === 0) {
    return null;
  }
  return (
    <div className={className ? className : "mb-4"}>
      <div className="mb-4 flex flex-wrap items-center gap-2 font-normal text-[#5E6D77]">
        {title && <p className="text-sm">{title}</p>}
        {priority && <p className="text-[13px]">※{t("Text priorities")}</p>}
      </div>
      {children}

      <CheckBox
        containerClassName={containerClassName}
        disabled={disabled}
        maxSelectable={maxSelectable}
        options={options}
        classNameProp={{
          style: { fontSize: "0.875rem" },
        }}
        defaultSelected={defaultSelected}
        onSelect={onSelect}
        groupNodes={groupNodes}
        isCheckbox={isCheckbox}
      />
    </div>
  );
};
